<script setup>
/**
 * The wall, mounted once in App.vue and opened by `requireEntitlement`
 * (src/billing.js) — never on launch, never on the board or a trip. Only when
 * somebody asks the phone to interrupt them, or once after a lapse.
 *
 * A sheet that slides up over whatever asked for it. NOT an `ion-content`: the
 * sheet scrolls its own body so the button, the terms and the links can stay
 * pinned to the bottom edge (PaywallSheet.vue), and `.ion-page` is what makes
 * a plain element fill an Ionic modal.
 */
import { IonModal } from '@ionic/vue';
import PaywallSheet from './PaywallSheet.vue';
import { billing, openExternalUrl, paywall, wall } from '../billing.js';

function close() {
  billing.closeWall(false);
}
</script>

<template>
  <ion-modal
    :is-open="wall.open"
    :backdrop-dismiss="true"
    class="paywall"
    @did-dismiss="close"
  >
    <div class="ion-page paywall-page">
      <PaywallSheet
        :view="paywall"
        @buy="billing.buy"
        @select="billing.select"
        @restore="billing.restore"
        @retry="billing.loadProducts"
        @close="close"
        @link="openExternalUrl"
      />
    </div>
  </ion-modal>
</template>

<style scoped>
.paywall-page {
  background: var(--la-carriage);
}
</style>
